import { todayIso } from '../dates'
import { formatShortDate } from '../query/dateRanges'
import type { NextAction } from '../query/types'

/**
 * "Volgende actie": the next open task, "Taak · 22 okt"; an overdue one reads "! 7 okt" in the
 * error colour, with "te laat" for a screen reader, so it stands out without colour. The title is
 * the tooltip. A task without a date reads just "Taak". An agreement's deadline (spec-63 E4) says
 * "Deadline" instead of "Taak".
 */
export function NextActionCell({ action, today = todayIso() }: { action: NextAction | null; today?: string }) {
  if (!action) return <span className="text-muted-foreground">—</span>
  const word = action.kind === 'deadline' ? 'Deadline' : 'Taak'
  const due = action.due_date ? formatShortDate(action.due_date, today) : null
  if (action.overdue) {
    return (
      <>
        <span title={action.title} className="font-semibold text-destructive">
          ! {due ?? word}
        </span>
        <span className="sr-only">te laat</span>
      </>
    )
  }
  return (
    <span title={action.title} className="text-muted-foreground">
      {due ? `${word} · ${due}` : word}
    </span>
  )
}
